export default {
    url: '/user',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canViewUsers() || PrivilegeService.canManageSkills();
        }
    },
    abstract: true,
    controller ($state, PrivilegeService) {
        this.$state = $state;
        this.PrivilegeService = PrivilegeService;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/index.js